import { adminGuard } from "@service/router/guards/guard";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { RouteConfig } from "vue-router/types/router";

export const adminRoutes = (startTemplate: string): RouteConfig[] => [
    {
        path: startTemplate + '/admin',
        component: () => import(/* webpackChunkName: "admin" */ '../../views/AdminView.vue'),
        beforeEnter: adminGuard,
        children: [
            {
                path: 'session/create',
                name: RouteNamesEnum.sessionCreate,
                component: () => import(/* webpackChunkName: "sessionEdit" */ '../../views/SessionEditView.vue'),
                meta: {
                    analyticName: 'SessionCreate'
                }
            },
            {
                path: 'session/:id/edit',
                name: RouteNamesEnum.sessionEdit,
                component: () => import(/* webpackChunkName: "sessionEdit" */ '../../views/SessionEditView.vue'),
                meta: {
                    analyticName: 'SessionEdit'
                }
            },
            {
                path: 'participants/import',
                name: RouteNamesEnum.participantsImport,
                component: () => import(/* webpackChunkName: "admin" */ '../../views/participants/ParticipantsImportView.vue'),
                meta: {
                    analyticName: 'ParticipantsImport'
                }
            }
        ]
    }
];
